import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConnectivityService {
  private onlineStatusSubject = new BehaviorSubject<boolean>(navigator.onLine);

  constructor() {
    // Listen for changes in network connectivity
    window.addEventListener('online', () => this.setOnlineStatus(true));
    window.addEventListener('offline', () => this.setOnlineStatus(false));
  }

  private setOnlineStatus(isOnline: boolean): void {
    this.onlineStatusSubject.next(isOnline);
  }

  // Get observable for online status
  get isOnline$() {
    return this.onlineStatusSubject.asObservable();
  }

  // Get current online status
  get isOnline(): boolean {
    return navigator.onLine;
  }
}
